import { Slide } from '@mui/material';
import React from 'react';
import * as S from './side-panel.styles';

export interface ISidePanelProps {
    className?: string;
    children?: React.ReactElement | (boolean | React.ReactElement)[];
}

// FIXME: force scroll to bottom of S.Scrollable
export const SidePanel: React.FunctionComponent<ISidePanelProps> = (props: ISidePanelProps): React.ReactElement => {
    const { className, children } = props;
    return (
        <Slide in={true} direction="left">
            <S.SidePanel className={className}>{children}</S.SidePanel>
        </Slide>
    );
};
